export * from './app-aside.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-aside/index.ts